module.exports = __webpack_public_path__ + "static/media/logo-type-white.a2d125e5.png";